Vue.component('ppcarto-switch', {
    template: `<div class="ppcarto-switch" v-if="show"><a href="#" @click.prevent="toggle()">{{text}}</a></div>`,
    data() {
        return {

        }
    },
    computed: {
        text(){
            let state = this.$store.getters.showMap;
            return state ? "show list" : "show map";
        },
        show(){
            return this.$store.getters.getHistory.length > 0;
        }
    },
    methods: {
        toggle(){
            this.$store.commit('toggleMap');
        }
    }
})
